import type { ChatStore } from "../Store";
import type { AwsRequestQuery } from "@/Modules/Chat/Models/Api/Chat";
import type { AllowedChatRoomItemType, DocumentChatRoomItem } from "@/Modules/Chat/Models/Domain/Chat";
import { ChatRoomItemType, FileTypes } from "@/Modules/Chat/Models/Domain/Chat";
import type { ChatSendDocumentEventMessageSocket } from "@/Modules/Chat/Models/WebSocket";
import { ChatRoomItemTypeMessageWebSocket, MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";

import { awsUploadFileRequest } from "@/Services/TherapyApi/Chat";
import AwsFileConnector from "@/Services/FileService/AwsFileConnector";

class SendDocumentActionHandler {
  constructor(
    private readonly chatStore: ChatStore,
    private readonly awsFileConnector = new AwsFileConnector()
  ) {}

  public async handle(file: File, chatId: string) {
    this.chatStore.isUploadingFile = true;

    const lastDot = file.name.lastIndexOf(".");
    let fileType = file.type ? file.type : file.name.substring(lastDot + 1);

    // THER-119: ojo, fallo de seguridad.
    if (fileType === "doc" || fileType === "docx") {
      fileType = "application/msword";
    }

    const awsRequestQuery: AwsRequestQuery = {
      content_type: fileType,
      file_name: file.name,
    };

    // THER-119: petición al servidor para obtener las credenciales de subida.

    try {
      const awsUploadRequestApiResponse = await awsUploadFileRequest(awsRequestQuery);

      if (this.isValidSize(awsUploadRequestApiResponse.max_size, file.size)) {
        await this.awsFileConnector.awsUploadFile(
          awsUploadRequestApiResponse,
          file,
          this.chatStore.setFileProgress
        );
        await this.sendDocumentMessageActionHandler(chatId, awsUploadRequestApiResponse.id, file, fileType);
      } else {
        this.handleError();
      }
    } catch (e: unknown) {
      this.handleError();
    } finally {
      this.chatStore.isUploadingFile = false;
    }
  }

  private isValidSize(maxSize: number, fileSize: number) {
    return maxSize > fileSize;
  }

  private handleError() {
    this.chatStore.setFileProgress(100);
    this.chatStore.showFileError(FileTypes.DOCUMENT);
  }

  // MWA-119: ENVIAR RESULTADO DE LA SUBIDA POR ELCHAT
  private sendDocumentMessageActionHandler(
    chatId: string,
    fileId: string,
    file: File,
    fileType: string
  ): Promise<AllowedChatRoomItemType> {
    return new Promise<AllowedChatRoomItemType>((resolve) => {
      const createdAt = new Date();

      // MWA-119: MENSAJE A TRAVES DEL SOCKET
      const sendTextEventPayload: ChatSendDocumentEventMessageSocket = {
        action: "",
        upload_id: fileId,
        size: file.size,
        file_name: file.name,
        chat: chatId,
        content_type: fileType,
        created: createdAt.getTime(),
        etype: ChatRoomItemTypeMessageWebSocket.DOCUMENT,
        extra: "",
        nonce: `chat:message:${chatId}:${this.chatStore.rooms[chatId].events.length}`,
        private: false,
        type: MessageTypeWebSocket.CHAT_ROOM_ITEM,
      };

      // MWA-119:INYECCIÓN A NUESTRO ESTADO DEL CHAT
      const event: DocumentChatRoomItem = {
        id: sendTextEventPayload.nonce,
        fileName: file.name,
        url: "",
        size: file.size,
        old: true,
        createdAt,
        type: ChatRoomItemType.OUTGOING_TEXT,
        isConfirmed: false,
        isReceived: false,
      };

      this.chatStore.rooms[chatId].events.push(event);
      this.chatStore.socketManager?.sendMessage(sendTextEventPayload);

      resolve(event);
    });
  }
}

export default SendDocumentActionHandler;
